import React, { useState } from 'react';

import clsx from 'clsx';

import { LoadingType, PreQualificationStep, setLoadingState, setPreQualificationStep } from 'actions';
import { setPrequalificationPortal } from 'actions/prequalificationPortal';
import { MenuBurgerImage, ProfileImage, SignOutImage } from 'assets/icons';
import { useAppDispatch } from 'hooks/useAppDispatch';
import { useAppSelector } from 'hooks/useAppSelector';
import useMobileCheck from 'hooks/useMobileCheck';
import { logout } from 'thunks';

import styles from './SignOut.module.scss';

interface SignOutProps {
  className?: string;
  href?: string;
}

const SignOut = ({ className, href }: SignOutProps) => {
  const dispatch = useAppDispatch();
  const { email } = useAppSelector((state) => state.account);
  const { firstName, lastName } = useAppSelector((state) => state.borrower);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const isMobile = useMobileCheck();
  const handleLogout = async () => {
    setIsMenuOpen(false);
    sessionStorage.clear();

    if (href) {
      localStorage.clear();
      window.location.href = href;

      return;
    } else {
      dispatch(setLoadingState({ type: LoadingType.GetData, loading: true }));
      dispatch(setPrequalificationPortal({ isNeedToClearLoanInformation: true }));
      await dispatch(logout());
      localStorage.clear();
      dispatch(setPreQualificationStep(PreQualificationStep.LoanAmount));
      dispatch(setLoadingState({ type: LoadingType.GetData, loading: false }));
    }
  };

  const handleMenuClick = () => {
    setIsMenuOpen((prevState) => !prevState);
  };

  const renderBorrowerName = () => <div className={styles.name}>{firstName + ' ' + lastName}</div>;
  const renderLogoutButton = () => (
    <div onClick={handleLogout} className={styles.logOutButton}>
      <div className={styles.signOutIcon}>
        <SignOutImage />
      </div>
      <div>Log out</div>
    </div>
  );

  return !isMobile ? (
    <div className={clsx(styles.signOutContainer, className)}>
      <div className={styles.profileIcon}>
        <ProfileImage />
      </div>
      <div className={styles.nameAndButtonContainer}>
        {renderBorrowerName()}
        {renderLogoutButton()}
      </div>
    </div>
  ) : (
    <>
      <div className={styles.activationMenuButton} onClick={handleMenuClick}>
        <MenuBurgerImage />
      </div>
      {isMenuOpen && (
        <div className={styles.menu}>
          <div className={styles.userInformation}>
            {renderBorrowerName()}
            <div className={styles.email}>{email}</div>
          </div>
          {renderLogoutButton()}
        </div>
      )}
    </>
  );
};

export default SignOut;
